import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createSocket } from "../../utils/constants";
import { useCasinoStyles } from "./useCasinoStyles";

export default function AAA() {
  const dispatch = useDispatch();
  const [roundProgress, setRoundProgress] = useState(100);
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);

  useCasinoStyles();

  useEffect(() => {
    createSocket("casino", dispatch, "aaa");
  }, [dispatch]);

  useEffect(() => {
    const duration = 10_000;
    const startedAt = performance.now();
    let animationFrame;

    const updateProgress = (now) => {
      const elapsedPercent = Math.min(((now - startedAt) / duration) * 100, 100);
      const progress = 100 - elapsedPercent;
      setRoundProgress(progress);
      if (progress > 0) animationFrame = requestAnimationFrame(updateProgress);
    };

    animationFrame = requestAnimationFrame(updateProgress);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <>
    <div data-v-61537a09="">
      <div data-v-61537a09="" className="detail-page-container">
        <div className="center-main-container">
          <div className="center-content">
            <div className="casino-container">
              <div className="casino-table vcasino vaaa">
                <div className="progress mobile-timer">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: "55%" }}
                  />
                </div>{" "}
                <div className="casino-video">
                  <div className="casino-video-title">
                    <span className="casino-name">V-Amar Akbar Anthony</span>{" "}
                    <div className="casino-video-rid">
                      Round ID: 321260921235337
                    </div>
                  </div>{" "}
                  <div className="video-box-container">
                    <div className="video-box" />
                  </div>{" "}
                  <div className="vcasino-cards">
                    <div className="text-center w-100">
                      <span data-v-79776e43="">
                        <img
                          data-v-79776e43=""
                          src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                        />
                      </span>
                    </div>
                  </div>{" "}
                  <div className="casino-video-right-icons">
                    <div title="Home" className="casino-video-home-icon">
                      <a
                        href="/admin/vcasino/list"
                        className=""
                        style={{ color: "var(--text-highlight)" }}
                      >
                        <i className="fas fa-home" />
                      </a>
                    </div>{" "}
                    <div title="Rules" className="casino-video-rules-icon">
                      <i className="fas fa-info-circle" />
                    </div>
                  </div>{" "}
                  <div>
                    {/**/} {/**/}
                  </div>
                </div>{" "}
                <div className="casino-detail">
                  <div className="main-odds">
                    <div className="vodds-box">
                      <div className="casino-bl-box">
                        <div className="back casino-bl-box-item">
                          <span className="casino-box-odd">2.12</span>
                        </div>{" "}
                        <div className="lay casino-bl-box-item">
                          <span className="casino-box-odd">2.22</span>
                        </div>
                      </div>{" "}
                      <div className="w-100 odds-book text-center book-red">0</div>
                    </div>{" "}
                    <div className="vodds-box">
                      <div className="casino-bl-box">
                        <div className="back casino-bl-box-item">
                          <span className="casino-box-odd">3.15</span>
                        </div>{" "}
                        <div className="lay casino-bl-box-item">
                          <span className="casino-box-odd">3.35</span>
                        </div>
                      </div>{" "}
                      <div className="w-100 odds-book text-center book-red">0</div>
                    </div>{" "}
                    <div className="vodds-box">
                      <div className="casino-bl-box">
                        <div className="back casino-bl-box-item">
                          <span className="casino-box-odd">4.15</span>
                        </div>{" "}
                        <div className="lay casino-bl-box-item">
                          <span className="casino-box-odd">4.45</span>
                        </div>
                      </div>{" "}
                      <div className="w-100 odds-book text-center book-red">0</div>
                    </div>{" "}
                    <div className="text-right w-100 aaa-min-max">
                      R: <span>25</span>-<span>25K</span>
                    </div>
                  </div>{" "}
                  <div className="other-odds">
                    <div className="oe-box">
                      <div className="even-box back-box">
                        <div>
                          <div className="dt-name">Even</div>{" "}
                          <div className="dt-odds">2.12</div>
                        </div>{" "}
                        <div className="dt-book w-100 book-red">0</div>
                      </div>{" "}
                      <div className="even-box back-box">
                        <div>
                          <div className="dt-name">Odd</div>{" "}
                          <div className="dt-odds">1.83</div>
                        </div>{" "}
                        <div className="dt-book w-100 book-red">0</div>
                      </div>{" "}
                      <div className="text-right w-100 aaa-min-max">
                        R: <span>25</span>-<span>10K</span>
                      </div>
                    </div>{" "}
                    <div className="color-box">
                      <div className="even-box back-box">
                        <div>
                          <div className="dt-name">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/spade.png" />{" "}
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/club.png" />
                          </div>{" "}
                          <div className="dt-odds">1.97</div>
                        </div>{" "}
                        <div className="dt-book w-100 book-red">0</div>
                      </div>{" "}
                      <div className="even-box back-box">
                        <div>
                          <div className="dt-name">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/heart.png" />{" "}
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/diamond.png" />
                          </div>{" "}
                          <div className="dt-odds">1.97</div>
                        </div>{" "}
                        <div className="dt-book w-100 book-red">0</div>
                      </div>{" "}
                      <div className="text-right w-100 aaa-min-max">
                        R: <span>25</span>-<span>10K</span>
                      </div>
                    </div>{" "}
                    <div className="uo-box">
                      <div className="even-box back-box">
                        <div>
                          <div className="dt-name">Under 7</div>{" "}
                          <div className="dt-odds">2</div>
                        </div>{" "}
                        <div className="dt-book w-100 book-red">0</div>
                      </div>{" "}
                      <div className="even-box back-box">
                        <div>
                          <div className="dt-name">Over 7</div>{" "}
                          <div className="dt-odds">2</div>
                        </div>{" "}
                        <div className="dt-book w-100 book-red">0</div>
                      </div>{" "}
                      <div className="text-right w-100 aaa-min-max">
                        R: <span>25</span>-<span>10K</span>
                      </div>
                    </div>{" "}
                    <div className="vcasino-card-box-top">
                      <div className="vcasino-card-odds">12</div>{" "}
                      <div className="vcasino-card-box-top">
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/A.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/2.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/3.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/4.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/5.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/6.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/7.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/8.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/9.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/10.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/J.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/Q.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                        <div className="vcasino-card-box">
                          <div className="d-inline-block">
                            <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/K.png" />
                          </div>{" "}
                          <div className="book-red">0</div>
                        </div>
                      </div>{" "}
                      <div className="text-right w-100 aaa-min-max">
                        R: <span>25</span>-<span>10K</span>
                      </div>
                    </div>
                  </div>{" "}
                  {/**/}{" "}
                  <div className="casino-video-last-results">
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resultc">
                      {/**/} {/**/} C {/**/}
                    </span>
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resultc">
                      {/**/} {/**/} C {/**/}
                    </span>
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resulta">
                      A {/**/} {/**/} {/**/}
                    </span>
                    <span className="resultb">
                      {/**/} B {/**/} {/**/}
                    </span>{" "}
                    {/**/} {/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="right-sidebar">
            <div className="right-sidebar">
              <div data-simplebar-auto-hide="true" data-simplebar="init">
                <div className="simplebar-wrapper" style={{ margin: 0 }}>
                  <div className="simplebar-height-auto-observer-wrapper">
                    <div className="simplebar-height-auto-observer" />
                  </div>{" "}
                  <div className="simplebar-mask">
                    <div
                      className="simplebar-offset"
                      style={{ right: 0, bottom: 0 }}
                    >
                      <div
                        className="simplebar-content-wrapper"
                        tabIndex={0}
                        role="region"
                        aria-label="scrollable content"
                        style={{ height: "auto", overflow: "hidden" }}
                      >
                        <div className="simplebar-content" style={{ padding: 0 }}>
                          <div className="casino-right-sidebar">
                            <div className="card m-b-10 my-bet">
                              <div className="card-header">
                                <h6 className="card-title float-left">My Bets</h6>{" "}
                                <a
                                  href="javascript:void(0)"
                                  className="btn btn-back float-right"
                                >
                                  View More
                                </a>
                              </div>{" "}
                              <div className="card-body1">
                                <div className="tab-content">
                                  <div id="matched-bet" className="tab-pane active">
                                    <div className="table-responsive1">
                                      <table className="table coupon-table table-striped mb-0">
                                        <thead>
                                          <tr>
                                            <th style={{ minWidth: 90 }}>
                                              UserName
                                            </th>{" "}
                                            <th
                                              className="text-right"
                                              style={{ minWidth: 50 }}
                                            >
                                              Rate
                                            </th>{" "}
                                            <th
                                              className="text-right"
                                              style={{ minWidth: 70 }}
                                            >
                                              Amount
                                            </th>
                                          </tr>
                                        </thead>{" "}
                                        <tbody>
                                          <tr>
                                            <td colSpan={4} className="text-center">
                                              No records found
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                            {/**/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  <div
                    className="simplebar-placeholder"
                    style={{ width: "auto", height: 100 }}
                  />
                </div>{" "}
                <div
                  className="simplebar-track simplebar-horizontal"
                  style={{ visibility: "hidden" }}
                >
                  <div
                    className="simplebar-scrollbar"
                    style={{ width: 0, display: "none" }}
                  />
                </div>{" "}
                <div
                  className="simplebar-track simplebar-vertical"
                  style={{ visibility: "hidden" }}
                >
                  <div
                    className="simplebar-scrollbar"
                    style={{ height: 0, display: "none" }}
                  />
                </div>
              </div>{" "}
              {/**/} {/**/}
            </div>
          </div>
        </div>
      </div>
    </div>
</>
  );
}

function CasinoRules({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      id="casino-vieo-rules"
      role="dialog"
      aria-modal="true"
      aria-label="Amar Akbar Anthony rules"
      className="casino-vieo-rules show d-none-small show-rules"
      style={{ display: "block" }}
    >
      <div className="rules-header">
        <div>Rules</div>
        <i className="fas fa-times" role="button" tabIndex={0} aria-label="Close rules" onClick={onClose} />
      </div>
      <div className="rules-body">
        <div className="rules-section">
          <ul className="pl-4 pr-4 list-style">
            <li>Amar Akbar Anthony is a 3-card casino game. Players can place bets on the available card and colour markets.</li>
            <li>The winning result is declared after the round timer reaches zero.</li>
            <li>All bets are settled according to the displayed game result and applicable game rules.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function CasinoResultModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      id="aaa-result-modal-outer"
      style={{ position: "fixed", inset: 0, zIndex: 1040 }}
      onClick={onClose}
    >
      <div
        id="aaa-result-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Amar Akbar Anthony result"
        className="modal fade show casino-result"
        style={{ display: "block" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-dialog modal-xl">
          <span tabIndex={0} />
          <div tabIndex={-1} className="modal-content">
            <header className="modal-header">
              <h5 className="modal-title">V-Amar Akbar Anthony Result</h5>
              <button type="button" aria-label="Close" className="close" onClick={onClose}>×</button>
            </header>
            <div className="modal-body">
              <div className="casino-result-round">
                <div>Round-ID: 321260921235337</div>
                <div>Match Time: <span>21/09/2026 23:27:48</span></div>
              </div>
            </div>
          </div>
          <span tabIndex={0} />
        </div>
      </div>
      <div className="modal-backdrop show" aria-hidden="true" />
    </div>
  );
}
